import React from 'react';
import './machine&deep-learning.css';

const m_wywl2 = () => {
    return (
        <div className="m_wywl__wrap">
            <div className="m_wywl container">
                <h3 className="m_wywl--title">Tools and languages</h3>
                <div className='m_wywl--list_block'>
                    <ul className='m_wywl--list'>
                        <li className='m_wywl--list_item'>R</li>
                        <li className='m_wywl--list_item'>Python SciPy, Pandas, etc</li>
                        <li className='m_wywl--list_item'>Scikit-learn</li>
                        <li className='m_wywl--list_item'>Tensorflow</li>
                        <li className='m_wywl--list_item'>Spark</li>
                        <li className='m_wywl--list_item'>MLlib</li>
                        <li className='m_wywl--list_item'>H20</li>
                    </ul>
                    <ul className='m_wywl--list'>
                        <li className='m_wywl--list_item'>WEKA</li>
                        <li className='m_wywl--list_item'>Pylearn2</li>
                        <li className='m_wywl--list_item'>Theano</li>
                        <li className='m_wywl--list_item'>Caffe</li>
                        <li className='m_wywl--list_item'>Torch</li>
                        <li className='m_wywl--list_item'>Azure Machine Learning API</li>
                        <li className='m_wywl--list_item'>and many more..</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default m_wywl2;